// eslint-disable-next-line import/prefer-default-export
export const richSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    subtype: 'OnlineStore',
    image: 'https://www.autotrader.com/content/static/img/icon/logos/atc-logo.svg',
    url: 'https://www.autotrader.com',
    sameAs: [
        'https://www.youtube.com/autotrader',
        'https://www.instagram.com/autotrader_com/',
        'https://x.com/AutoTrader_com',
        'https://www.facebook.com/autotrader',
        'https://en.wikipedia.org/wiki/Autotrader.com',
    ],
    logo: 'https://www.autotrader.com/content/static/img/icon/logos/atc-logo.svg',
    name: 'Autotrader',
    description: 'Our mission at Autotrader is to be your ultimate online solution for buying and selling new, certified and used cars. Our site is designed to give you more control of the buying process and make finding a vehicle easier than ever before.\nWhether you’re shopping for a new, certified or used car, our website offers you these benefits:\n- The largest selection of vehicle inventory from dealers and private sellers\n- The most comprehensive selection of buying and selling tips\n- The most complete research and compare tools, including reviews, photos, videos and more\n- Vehicle pricing, including seller specials and dealer discounts\n- Safety information and vehicle history reports\n- Help with finance, insurance and warranty programs\nNot sure which type of car you want? That’s okay. Autotrader lets you research and compare new, certified and used cars by searching for body type, mileage, price and numerous other criteria. Our Lifestyle Centers allow you to locate vehicles that meet your needs and compare them side by side. Autotrader is the only website with more than 3 million vehicle listings from 40,000 dealers and 250,000 private owners. We provide the largest selection of vehicles and attract more than 14 million qualified buyers each month.',
    telephone: '+1-866-288-6872',
    address: {
        '@type': 'PostalAddress',
        streetAddress: '3003 Summit Blvd NE',
        addressLocality: 'Atlanta',
        addressCountry: 'US',
        addressRegion: 'GA',
        postalCode: '30319',
    },
    subOrganization: [{
        name: 'Autotrader Classic Cars & Trucks',
        email: 'Classicscustomerservice@autotrader.com',
        telephone: '1-800-548-8889',
        url: 'https://classics.autotrader.com/',
        logo: 'https://classics.autotrader.com/img/logo-mobile-white-2024.png',
        image: 'https://classics.autotrader.com/img/logo-mobile-white-2024.png',
        address: [{
            '@type': 'PostalAddress',
            streetAddress: '3003 Summit Blvd',
            addressLocality: 'Atlanta',
            addressRegion: 'GA',
            postalCode: '30319',
            addressCountry: 'US',
        }],
    },
    {
        name: 'Autotrader RVs',
        email: 'Classicscustomerservice@autotrader.com',
        telephone: '1-800-548-8889',
        url: 'https://rvs.autotrader.com/',
        logo: 'https://rvs.autotrader.com/img/logo-mobile-rvs-white-2024.png',
        image: 'https://rvs.autotrader.com/img/logo-mobile-rvs-white-2024.png',
        address: [{
            '@type': 'PostalAddress',
            streetAddress: '3003 Summit Blvd',
            addressLocality: 'Atlanta',
            addressRegion: 'GA',
            postalCode: '30319',
            addressCountry: 'US',
        }],
    },
    {
        name: 'Autotrader Motorcycles',
        email: 'Classicscustomerservice@autotrader.com',
        telephone: '1-800-548-8889',
        url: 'https://motorcycles.autotrader.com/',
        logo: 'https://motorcycles.autotrader.com/img/logo-mobile-motorcycles-white-2024.png',
        image: 'https://motorcycles.autotrader.com/img/logo-mobile-motorcycles-white-2024.png',
        address: [{
            '@type': 'PostalAddress',
            streetAddress: '3003 Summit Blvd NE',
            addressLocality: 'Atlanta',
            addressCountry: 'US',
            addressRegion: 'GA',
            postalCode: '30319',
        }],
    },
    {
        name: 'Autotrader Classic Cars & Trucks',
        email: 'Classicscustomerservice@autotrader.com',
        telephone: '1-800-548-8889',
        url: 'https://classics.autotrader.com/',
        logo: 'https://classics.autotrader.com/img/logo-mobile-white-2024.png',
        image: 'https://classics.autotrader.com/img/logo-mobile-white-2024.png',
        address: [{
            '@type': 'PostalAddress',
            streetAddress: '3003 Summit Blvd',
            addressLocality: 'Atlanta',
            addressRegion: 'GA',
            postalCode: '30319',
            addressCountry: 'US',
        }],
    },
    {
        name: 'Autotrader Buy Here Pay Here',
        url: 'https://buyherepayhere.autotrader.com/',
        email: 'BHPHSupportEmails@autotrader.com',
        logo: 'https://buyherepayhere.autotrader.com/dist/img/logo-bhph.png',
        image: 'https://buyherepayhere.autotrader.com/dist/img/logo-bhph.png',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+1-877-204-2526',
            contactType: 'Dealer Customer Service',
            contactOption: 'TollFree',
            areaServed: 'United States',
            availableLanguage: 'English',
        },
    },
    ],
    department: [{
        name: 'Private Seller Support',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '1-866-288-6872',
            contactType: 'Private Seller Customer Support',
            contactOption: 'TollFree',
            areaServed: 'United States',
            availableLanguage: 'English',
        },
    },
    {
        name: 'Private Seller and Buyer Payment and Financing',
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: '1-800-736-1777',
            contactType: 'Payment and Financing',
            contactOption: 'TollFree',
            areaServed: 'United States',
            availableLanguage: 'English',
        },
    },
    ],
    parentOrganization: {
        '@type': 'Organization',
        '@id': 'https://www.coxautoinc.com',
        name: 'Cox Automotive Inc',
        description: 'We focus on continually improving our products to create faster vehicle transactions, enabling consumers to have a seamless online-to-offline experience. Learn more about how Cox Automotive solutions can take every aspect of your business further, faster.',
        image: ['https://www.coxautoinc.com/wp-content/themes/coxautoinc/dist/images/logo-brand-stacked.svg',
        ],
        logo: 'https://www.coxautoinc.com/wp-content/themes/coxautoinc/dist/images/logo-brand-stacked.svg',
        url: 'https://www.coxautoinc.com/',
        telephone: '+1-855-269-2886',
        address: [{
            '@type': 'PostalAddress',
            streetAddress: '3003 Summit Blvd',
            addressLocality: 'Atlanta',
            addressRegion: 'GA',
            postalCode: '30319',
            addressCountry: 'US',
        }],
    },
};
